import {Query, QuerySingle, WorkflowObjectState} from 'olympe';

/**
 * @param cloudObject
 * @return {Promise<?Array<*>>}
 */
export const getCloudObjectWorkflowHistory = async (cloudObject) => {
    return (await Query.from(cloudObject).follow(WorkflowObjectState.objectRel.getInverse()).andReturn().execute()).toArray();
}

/**
 * @param cloudObject
 * @return {Promise<?WorkflowObjectState>}
 */
export const getCurrentWorkflowObject = async (cloudObject) => {
    return (await QuerySingle.from(cloudObject).follow(WorkflowObjectState.currentObjectRel.getInverse()).execute());
}
